import { render, staticRenderFns } from "./FormComponentFile.vue?vue&type=template&id=126ab8da"
import script from "./FormComponentFile.vue?vue&type=script&lang=js"
export * from "./FormComponentFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports